import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as GroupsIcon } from "../../../../../assets/images/People/Customers/groups.svg";
import CustomerDetailChip from "./CustomerDetailChip";

const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  p: 3,
  boxSizing: "border-box",
};

export default function CustomerDetailGroupsTeam({ customer }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Groups
      </Typography>
      <Box sx={sectionCardSx}>
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <GroupsIcon />
            <Typography
              sx={{
                color: "#405261",
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              Groups
            </Typography>
          </Box>
          <CustomerDetailChip label={customer.groupLabel} />
        </Box>
      </Box>
    </Box>
  );
}
